module.exports = __webpack_public_path__ + "img/16.6b24b2e.png";